import { PersonDto } from './personDto'
import * as yup from 'yup'

export class VehicleDamageNoteDto {
  vehicleDamageNoteId?: string = undefined
  note?: string = undefined
  createdBy?: PersonDto = undefined
  createdDateTime?: string = undefined
}

export const vehicleDamageNoteValidationSchema = yup.object({
  note: yup.string().max(255, 'Note cannot be more than 255 characters.').required('Note is required.')
})
